AFRAME.registerComponent('main-menu', {
    schema: {},

    init: function () {
        this.createButtons();
        this.createSearchField();
        this.createUserButtons();
    },
    createButtons: function () {
        const buttonLabels = ['Home', '3D Chart', 'Plots',
            'River', 'News', 'Compare' ];
        this.defaultSelectLabel = 'Home'
        const buttonWidth = 2.8;
        const buttonHeight = 1.33
        const spacing = 0.3;
        const startX = -((buttonWidth * buttonLabels.length + spacing * (buttonLabels.length - 1)) / 2) + buttonWidth / 2;
        const startY = (buttonHeight + spacing) / 2
        const z = 0.01;

        this.buttonWidth = buttonWidth;
        this.buttonHeight = buttonHeight;
        this.buttonSpacing = spacing;
        this.buttonStartX = startX;
        this.buttonRowY = startY;

        this.buttons = [];

        buttonLabels.forEach((label, index) => {
            const x = startX + index * (buttonWidth + spacing);
            const position = `${x} ${startY} ${z}`;
            this.createMenuButton(this.el, label, position, buttonWidth, buttonHeight);
        });
    },
    createSearchField: function () {
        const fieldWidth = 10.5;
        const fieldHeight = this.buttonHeight || 1.33;
        const positionX = (this.buttonStartX + fieldWidth / 2 - this.buttonWidth / 2)|| 0
        const positionY = -(this.buttonHeight + this.buttonSpacing) / 2
        const z = 0.01;

        const field = document.createElement('a-entity');
        field.setAttribute('ui-button', {
            label: '',
            type: 'rounded-box',
            width: fieldWidth,
            height: fieldHeight,
            depth: 0.02,
            colorScheme: 'primary',
            autosize: false,
            isSelectable: false,
            radius: 0.2
        });
        field.setAttribute('position', `${positionX} ${positionY} ${z}`);
        this.searchFieldWidth = fieldWidth;
        const placeholder = document.createElement('a-troika-text');
        placeholder.setAttribute('value', 'Seach for stock ticker or company');
        placeholder.setAttribute('color', '#B0B3B8');
        placeholder.setAttribute('font-size', 0.4);
        placeholder.setAttribute('align', 'left');
        placeholder.setAttribute('anchor', 'left');
        placeholder.setAttribute('baseline', 'center');
        placeholder.setAttribute('max-width', fieldWidth - 0.18);
        placeholder.setAttribute('position', `${-fieldWidth / 2 + 0.6 + this.buttonSpacing * 2} 0 0.015`);

        const icon = document.createElement('a-image');
        icon.setAttribute('src', './vr-assets/navigation-bottom/search.svg');
        icon.setAttribute('width', 0.6);
        icon.setAttribute('height', 0.6);
        icon.setAttribute('position', `${-fieldWidth / 2 + 0.6} 0 0.015`);

        field.appendChild(placeholder);
        field.appendChild(icon);
        this.el.appendChild(field);
        this.searchField = field;
    },
    createUserButtons: function () {
        const y =  -(this.buttonHeight + this.buttonSpacing) / 2
        const z = 0.01;
        const spacing = this.buttonSpacing || 0.02;
        const userButtonWidth = 3.5
        const userButtonHeight = this.buttonHeight || 0.12;

        const startX = 3.6

        const configs = [
            { image: './vr-assets/navigation-bottom/watchlist.svg', label: 'Watchlist' },
            { image: './vr-assets/navigation-bottom/user.svg', label: 'Log in' }
        ];

        this.userButtons = [];
        configs.forEach((cfg, index) => {
            const x = startX + index * (userButtonWidth + spacing);
            const btn = document.createElement('a-entity');
            btn.setAttribute('ui-button', {
                label: cfg.label,
                image: cfg.image,
                type: 'image-text',
                width: userButtonWidth,
                height: userButtonHeight,
                depth: 0.02,
                colorScheme: 'primary',
                autosize: false,
                isSelectable: false,
                radius: 0.2,
                preferredFontSize: 0.5
            });
            btn.setAttribute('position', `${x} ${y} ${z}`);
            btn.setAttribute('data-raycastable', '');
            btn.setAttribute('data-label', cfg.label);

            this.el.appendChild(btn);
            this.userButtons.push(btn);
        });
    },
    createMenuButton: function (parent, label, position, buttonWidth, buttonHeight) {
        const button = document.createElement('a-entity');
        button.setAttribute('ui-button', {
            label: label,
            type: 'rounded-box',
            width: buttonWidth,
            height: buttonHeight,
            depth: 0.02,
            colorScheme: 'primary',
            autosize: false,
            isSelectable: true,
            radius: 0.2,
            preferredFontSize: 0.5,
        });
        button.setAttribute('position', position);
        button.setAttribute('data-raycastable', '');
        button.setAttribute('data-label', label);

        if (this.isComingSoonLabel(label)) {
            this.addComingSoonTooltip(button);
        }

        parent.appendChild(button);
        this.buttons.push(button);

        button.addEventListener('click', (event) => {
            this.selectButton(button);
        });

        if (label === this.defaultSelectLabel) {
            setTimeout(() => {
                this.selectButton(button);
            }, 200);
        }
    },
    isComingSoonLabel: function (label) {
        return label === 'Plots' || label === 'River' || label === 'News' || label === 'Compare';
    },
    addComingSoonTooltip: function (button) {
        const tooltipContainer = document.createElement('a-entity');
        tooltipContainer.setAttribute('visible', false);
        tooltipContainer.setAttribute('position', '0 0.9 0.06');
        button.appendChild(tooltipContainer);

        const tooltipBg = document.createElement('a-entity');
        tooltipBg.setAttribute('rounded-box', {
            width: 1.7,
            height: 0.32,
            depth: 0.01,
            radius: 0.06,
            color: '#111111',
            opacity: 1,
            cornerstyle: 'ext'
        });
        tooltipBg.setAttribute('position', '0 0 0');
        tooltipContainer.appendChild(tooltipBg);

        const tooltipText = document.createElement('a-troika-text');
        tooltipText.setAttribute('value', 'Coming soon');
        tooltipText.setAttribute('font-size', 0.16);
        tooltipText.setAttribute('align', 'center');
        tooltipText.setAttribute('baseline', 'center');
        tooltipText.setAttribute('position', '0 0 0.01');
        tooltipText.setAttribute('color', '#FFFFFF');
        tooltipContainer.appendChild(tooltipText);

        button.addEventListener('mouseenter', () => {
            tooltipContainer.setAttribute('visible', true);
        });

        button.addEventListener('mouseleave', () => {
            tooltipContainer.setAttribute('visible', false);
        });
    },
    selectButton: function (button) {
        this.buttons.forEach(btn => {
            if (btn && btn !== button) {
                btn.setAttribute('ui-button', 'selected', false);
                btn.setAttribute('scale', '1 1 1');
            }
        });

        this.selectedButton = button;
        button.setAttribute('ui-button', 'selected', true);
        button.setAttribute('scale', '1.05 1.05 1.05');
    }
})
